import { render } from "./DialogErrorTentativeReservation.vue?vue&type=template&id=1dcad50c"
import script from "./DialogErrorTentativeReservation.vue?vue&type=script&lang=js"
export * from "./DialogErrorTentativeReservation.vue?vue&type=script&lang=js"
script.render = render

export default script